const NextAppBasePaths = {
  "/auth": "auth",
  "/public-recruiting": "public-recruiting"
};

export { NextAppBasePaths as default };
//# sourceMappingURL=nextAppBasePaths.mjs.map
